// extracted by mini-css-extract-plugin
module.exports = {"container":"ShareChallengeBox_container__2mSd8","eventNameTitle":"ShareChallengeBox_eventNameTitle__13NNE","detailsContainer":"ShareChallengeBox_detailsContainer__2z68c"};